import { FC, memo } from 'react'
import { Link } from 'react-router-dom'

import s from './error.module.scss'

import Header from '../../components/UI/Header'

import Er from 'assets/404.png'
import logo from 'assets/svg/logo-color-on-black.svg'
import logofooter from 'assets/svg/logo-mono-on-black.svg'

const NotFound: FC = memo(() => {
  return (
    <main className={s.wrapper}>
      <Header className={s.headerWrapper}>
        <Link to="publisher/dashboard">
          <img src={logo} alt="" />
        </Link>
      </Header>
      <div className={s.errorWrapper}>
        <div className={s.error}>
          <img src={Er} alt="" />
        </div>
        <div className={s.textWrapper}>
        <p className={s.text}>
          The Page you’re looking for doesn’t exist. <br />
          <Link to="publisher/dashboard">Go Home</Link>
          &nbsp; or navigate through bottom menu.
        </p>
        </div>
      </div>
      <footer className={s.footerNotfound}>
        <div className={s.footerNotfound__grid}>
          <div className={s.footerNotfound__item}>
            <img src={logofooter} alt="" />
            <p className={s.copy}>© Meta Ads 2021, All rights reserved.</p>
          </div>
          <div className={s.footerNotfound__item}>
            <h3 className={s.title}>Business</h3>
            <ul className={s.menu}>
              <li>
                <a
                  href="https://www.notion.so/Meta-Ads-Lightpaper-fd28422162034f39aa6dfd914b413880"
                  target="_blank"
                  rel="noreferrer"
                >
                  Light Paper
                </a>
              </li>
              <li>
                <a href="https://forms.gle/9YfDHYJhNYuswrrR6" target="_blank" rel="noreferrer">
                  Become a Team Member
                </a>
              </li>
              <li>
                <a href="https://forms.gle/wYbzXKqVXYzWVMUL7" target="_blank" rel="noreferrer">
                  Connect a Surface
                </a>
              </li>
              <li>
                <a href="https://forms.gle/ud9wxjjbVB5hRV887" target="_blank" rel="noreferrer">
                  Order Ads
                </a>
              </li>
              <li>
                <a href="https://forms.gle/5Y4hW7zWrcTKNdLv9" target="_blank" rel="noreferrer">
                  Investors
                </a>
              </li>
            </ul>
          </div>
          <div className={s.footerNotfound__item}>
            <h3 className={s.title}>Social</h3>
            <ul className={s.menu}>
              <li>
                <a href="https://discord.gg/Pw2dxxbdTu" target="_blank" rel="noreferrer">
                  Discord
                </a>
              </li>
              <li>
                <a href="https://t.me/+rPEWHyKEYVZjMTI6" target="_blank" rel="noreferrer">
                  Telegram
                </a>
              </li>
              <li>
                <a href="https://twitter.com/ads_meta" target="_blank" rel="noreferrer">
                  Twitter
                </a>
              </li>
              <li>
                <a href="https://medium.com/@Meta_Ads" target="_blank" rel="noreferrer">
                  Medium
                </a>
              </li>
            </ul>
          </div>
          <div className={s.footerNotfound__item}>
            <h3 className={s.title}>Smart Contract</h3>
            <ul className={s.menu}>
              <li>
                <a href="https://github.com/MetaAdsTeam" target="_blank" rel="noreferrer">
                  Github
                </a>
              </li>
              <li>
                <a href="#0" target="_blank" rel="noreferrer">
                  Audit (Coming Soon)
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </main>
  )
})

export default NotFound
